import React from 'react';
import styles from './change-preview-slide-scale.less';
import i18n from '@i18next/i18n';
import classNames from 'classnames';

export enum EScaleType {
    BIG,
    SMALL,
}

interface IChangePreviewSlideScaleProps {
    scaleType: EScaleType;
    onChange?(scaleType: EScaleType): void;
}

export class ChangePreviewSlideScale extends React.Component<IChangePreviewSlideScaleProps, any> {
    render() {
        const bigButtonClass = classNames({
            [styles['button-container']]: true,
            [styles['button-selected']]: this.props.scaleType === EScaleType.BIG,
        });
        const smallButtonClass = classNames({
            [styles['button-container']]: true,
            [styles['button-selected']]: this.props.scaleType === EScaleType.SMALL,
        });

        return <div className={styles['button-group-container']}>
            <div
                className={bigButtonClass}
                onClick={() => {
                    this.props.onChange?.(EScaleType.BIG);
                }}>
                {
                    i18n.t('大图')
                }
            </div>
            <div
                className={smallButtonClass}
                onClick={() => {
                    this.props.onChange?.(EScaleType.SMALL);
                }}>
                {
                    i18n.t('小图')
                }
            </div>
            <div></div>
        </div>;
    }
}
